import { render, staticRenderFns } from "./ChoicesView.vue?vue&type=template&id=061dac25&scoped=true&"
import script from "./ChoicesView.vue?vue&type=script&lang=ts&"
export * from "./ChoicesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061dac25",
  null
  
)

export default component.exports